import { render, staticRenderFns } from "./userProfileEntityDataWorkflows.vue?vue&type=template&id=2fed4851&scoped=true"
import script from "./userProfileEntityDataWorkflows.vue?vue&type=script&lang=js"
export * from "./userProfileEntityDataWorkflows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fed4851",
  null
  
)

export default component.exports